import React from 'react';
import { Phone, Globe, MapPin, ShieldCheck, HardHat, Handshake, Users } from 'lucide-react';
import { BUILDBROZ_LOGO_URL } from '../branding';

const CONTACT = [
  { icon: Phone, text: '440-381-7828' },
  { icon: Phone, text: '216-695-1565' },
  { icon: Globe, text: 'www.BuildBroz.com' },
  { icon: MapPin, text: 'Cleveland, Ohio' },
];

const VALUE_PROPS = [
  { icon: ShieldCheck, text: 'Quality Workmanship' },
  { icon: HardHat, text: 'Reliable & Professional' },
  { icon: Handshake, text: 'Built on Trust' },
  { icon: Users, text: 'Committed to Your Project' },
];

// Black brand band at the top of every customer-facing document.
export const DocHeader = () => (
  <div className="bg-black border-b-[3px] border-[#D4AF37] px-5 sm:px-8 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5" data-testid="doc-brand-header">
    <div className="flex items-center gap-3">
      <img src={BUILDBROZ_LOGO_URL} alt="BuildBroz" className="h-16 w-16 object-contain mix-blend-screen select-none" data-testid="doc-brand-logo" />
      <div>
        <div className="font-brand font-black text-2xl sm:text-[26px] tracking-tight text-white leading-none">BUILD<span className="text-[#D4AF37]">BROZ</span></div>
        <div className="font-brand text-[10px] text-gray-300 uppercase tracking-[0.28em] mt-1.5">Construction &amp; Remodeling</div>
      </div>
    </div>
    <div className="space-y-1.5" data-testid="doc-brand-contact">
      {CONTACT.map(({ icon: Icon, text }) => (
        <div key={text} className="flex items-center gap-2.5 text-sm text-white">
          <Icon size={14} className="text-[#D4AF37] shrink-0" />
          <span className="font-medium">{text}</span>
        </div>
      ))}
    </div>
  </div>
);

// Black footer band with value props + angled gold thank-you panel.
export const DocFooter = () => (
  <div className="bg-black flex flex-col lg:flex-row items-stretch overflow-hidden" data-testid="doc-brand-footer">
    <div className="flex-1 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-5 px-5 sm:px-8 py-6">
      {VALUE_PROPS.map(({ icon: Icon, text }, i) => (
        <div key={text} className={`flex flex-col items-center text-center gap-2 ${i > 0 ? 'sm:border-l sm:border-[#D4AF37]/25 sm:pl-4' : ''}`}>
          <Icon size={22} className="text-[#D4AF37]" />
          <span className="font-brand text-[9px] font-bold uppercase tracking-[0.12em] text-[#D4AF37] leading-snug">{text}</span>
        </div>
      ))}
    </div>
    <div className="relative bg-[#D4AF37] px-8 py-6 lg:min-w-[290px] lg:pl-16 flex flex-col items-center justify-center text-center lg:[clip-path:polygon(14%_0,100%_0,100%_100%,0_100%)]">
      <div className="font-script text-4xl text-black leading-none -rotate-2" data-testid="doc-footer-script">let&apos;s build it.</div>
      <div className="font-brand text-[10px] font-extrabold text-black uppercase tracking-wide mt-2 leading-relaxed">
        Thank you for the opportunity<br />to work with you!
      </div>
    </div>
  </div>
);
